import { render } from "./Sv047.vue?vue&type=template&id=fe01e37a&scoped=true"
import script from "./Sv047.vue?vue&type=script&lang=js"
export * from "./Sv047.vue?vue&type=script&lang=js"

import "./Sv047.vue?vue&type=style&index=0&id=fe01e37a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe01e37a"]])

export default __exports__